import React from 'react'
import styled, { css } from 'styled-components'
import { animated } from 'react-spring'
import { device } from 'heliocor-ui'

export const Container = styled('div')`
    position: fixed;
    z-index: 1000;
    top: ${props => (props.top ? '30px' : 'unset')};
    bottom: ${props => (props.top ? 'unset' : '10vh')};
    width: 95vw;
    margin: 0 auto;
    left: 2.5vw;
    display: flex;
    flex-direction: ${props => (props.top ? 'column-reverse' : 'column')};
    pointer-events: none;
    align-items: ${props => (props.position === 'center' ? 'center' : `flex-${props.position || 'end'}`)};
    @media ${device.midSize}{
        left: 30px;
        width: auto;
        align-items: center;
        top: ${props => (props.top ? '30px' : 'unset')};
        bottom: ${props => (props.top ? 'unset' : '30px')};
    }
`

export const Message = styled(animated.div)`
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    width: 30ch;
    @media (max-width: 680px) { 
        width: 100%;
    }
`


export const Content = styled.div(({
    theme: {colors}, canClose, top, color
}) => css`
    color: ${colors.grey100};
    background-color: ${colors.grey700};
    border-left: .5rem solid ${colors[color]};
    opacity: 0.9;
    padding: 7px 22px;
    font-size: 0.7rem;
    display: grid;
    grid-template-columns: ${canClose === false ? '1fr' : '1fr auto'};
    grid-gap: 10px;
    overflow: hidden;
    height: auto;
    border-radius: 3px;
    margin-top: ${top ? '0' : '10px'};
    margin-bottom: ${top ? '10px' : '0'};
`)

export const ButtonSnack = styled('button')`
    cursor: pointer;
    pointer-events: all;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    outline: 0;
    border: none;
    background: transparent;
    display: flex;
    align-self: flex-end;
    overflow: hidden;
    margin: 0;
    padding: 0;
    color: rgba(255, 255, 255, 0.5);
    :hover {
        color: rgba(255, 255, 255, 0.6);
    }
`

export const Life = styled(({lifeColor, ...rest}) => <animated.div {...rest} />)`
    position: absolute;
    bottom: ${props => (props.top ? '10px' : '0')};
    left: 0px;
    width: auto;
    background-image: linear-gradient(
        130deg, 
        ${props => props.theme.colors[props.lifeColor]}, 
        ${props => props.theme.colors.white}
    );
    height: 5px;
`
